import { useNavigate, useLocation, useParams } from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const history = {
    push: (path) => navigate(path),
    replace: (path) => navigate(path, { replace: true }),
    go: (n) => navigate(n),
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    location
  };

  const match = {
    params,
    isExact: location.pathname === location.pathname, // This is always true in v6
    path: location.pathname,
    url: location.pathname,
  };


  return { navigate, location, params, history, match };
}